/**
 * Компактный десктоп = ширина 1025-1400px: узкие мониторы и POS-терминалы.
 * Уже - мобильная раскладка (@lg), шире - обычный десктоп.
 * В стилях та же граница - LESS-миксин .media-compact-pc.
 */
export const COMPACT_MIN_WIDTH = 1025
export const COMPACT_MAX_WIDTH = 1400

export default {
  computed: {
    isCompactScreen () {
      const width = this.$vuetify.breakpoint.width
      return width >= COMPACT_MIN_WIDTH && width <= COMPACT_MAX_WIDTH
    },
  },
}
